import React, { useState } from 'react'
import styles from './StyleGuide.module.css'
import Modal from './Modal'
import Header from './Header'


const StyleGuidePage = () => {
    const [primary, setPrimary] = useState(true)
    const [secondary, setSecondary] = useState(false)

    const [showModal1, setShowModal1] = useState(false)
    const [showModal2, setShowModal2] = useState(false)
    const [showModal3, setShowModal3] = useState(false)
    const [showModal4, setShowModal4] = useState(false)
    const [showModal5, setShowModal5] = useState(false)
    const [showModal6, setShowModal6] = useState(false)
    const [showModal7, setShowModal7] = useState(false)
    const [showModal8, setShowModal8] = useState(false)
    const [showModal9, setShowModal9] = useState(false)
    const [showModal10, setShowModal10] = useState(false)
    const [showModal11, setShowModal11] = useState(false)
    const [showModal12, setShowModal12] = useState(false)
    const [showModal13, setShowModal13] = useState(false)
    const [showModal14, setShowModal14] = useState(false)
    const [showModal15, setShowModal15] = useState(false)

    const handlePrimaryClick = () => {
        setPrimary(true)
        setSecondary(false)
    }

    const handleSecondaryClick = () => {
        setSecondary(true)
        setPrimary(false)
    }

    const copySnippet = async (e, id) => {
        const text = document.getElementById(id).innerText;
        const btn = e.target;

        try {
            await navigator.clipboard.writeText(text);
            btn.classList.add(styles.copiedBtn);
            btn.textContent = "Copied!";
            setTimeout(() => {
                btn.classList.remove(styles.copiedBtn);
                btn.textContent = "Copy Snippet";
            }, 1000);
        } catch (err) {
            console.error('Failed to copy: ', err);
        }
    }

    return (
        <>
            <Header />
            <h1>Style Guide</h1>
            <div className={styles.background}>
                <div className={styles.columncontainer}>
                    <div className={styles.col}>
                        <section>
                            <h2 className={styles.sectionHeader}>Typography</h2>
                            <hr />
                            <div className={styles.josefinName}>Josefin Sans - [Forms/Buttons, Search, General text]</div>
                            <div className={styles.bungeeName}>Bungee - [All Pages] </div>
                            <div className={styles.kaiTiName}>KaiTi - Chinese Version [Forms/Buttons, Search, General text]</div>
                            <div className={styles.fangsongName}>FangSong - Chinese Version [All Pages] </div>
                        </section>
                        <section>
                            <h2 className={styles.sectionHeader}>Palette</h2>
                            <hr />
                            <label htmlFor='colorsContainer' className={styles.colorsLabel}>Click a color for more information</label>
                            <div id="colorsContainer" className={styles.colorsContainer}>
                                <div onClick={() => setShowModal1(true)} className={styles.colorBox1}>#793CC6</div>
                                <div onClick={() => setShowModal9(true)} className={styles.colorBox9}>#F4C41A</div>
                                <div onClick={() => setShowModal10(true)} className={styles.colorBox10}>#29193</div>
                                <div onClick={() => setShowModal2(true)} className={styles.colorBox2}>#D1B140</div>
                                <div onClick={() => setShowModal5(true)} className={styles.colorBox5}>#8E78390</div>
                                <div onClick={() => setShowModal6(true)} className={styles.colorBox6}>#35214E -{'>'} #40B7D1</div>
                                <div onClick={() => setShowModal3(true)} className={styles.colorBox3}>#34393d</div>
                                <div onClick={() => setShowModal15(true)} className={styles.colorBox15}>#4C5359</div>
                                <div onClick={() => setShowModal4(true)} className={styles.colorBox4}>#ffffff</div>
                                <div onClick={() => setShowModal8(true)} className={styles.colorBox8}>#1E1E1E</div>
                                <div onClick={() => setShowModal7(true)} className={styles.colorBox7}>#FF0000</div>
                                <div onClick={() => setShowModal11(true)} className={styles.colorBox11}>#00FF00</div>
                                <div onClick={() => setShowModal12(true)} className={styles.colorBox12}>#0D9C00</div>
                                <div onClick={() => setShowModal13(true)} className={styles.colorBox13}>#FFE6E6</div>
                                <div onClick={() => setShowModal14(true)} className={styles.colorBox14}>#E6FFE6</div>
                            </div>
                        </section>
                    </div>
                    <div className={styles.col}>
                        <section>
                            <h2 className={styles.sectionHeader}>Alerts</h2>
                            <hr />
                            <div className={styles.errorBar}>Error</div>
                            <div className={styles.successBar}>Success</div>
                            <pre className={styles.codeSnippet}>
                                <code id="errorCode">
                                    color: #ff0000;
                                    <br />
                                    font-size: 14px;
                                    <br />
                                    margin-top: 4px;
                                    <br />
                                    margin-bottom: 4px;
                                    <br />
                                    font-weight: bold;
                                    <br />
                                    padding: 8px;
                                    <br />
                                    border: 1px solid #ff0000;
                                    <br />
                                    border-radius: 10px;
                                    <br />
                                    background: #ffe6e6;
                                </code>
                            </pre>
                            <button onClick={(e) => copySnippet(e, "errorCode")} className={styles.copyBtn}>
                                Copy Snippet
                            </button>
                        </section>
                        <section>
                            <h2>Page Layouts</h2>
                            <hr />
                            <div className={styles.layoutContainer}>
                                <div>
                                    <h3>3 Column</h3>
                                    Pages: Feed, Communities, Find Players
                                    <br /><br />
                                    <p style={{ textAlign: "left" }}>The 3 columns are a result of either setting the width of 3 divs as 30%, or importing and using the PostingList component with 2 divs</p>
                                    <br /><br />
                                    <p style={{ textAlign: "left" }}>HTML</p>
                                    <pre className={styles.codeSnippet}>
                                        <code id="threeColHTML">
                                            &lt;h1&gt;Page Heading&lt;/h1&gt;
                                            <br />
                                            &lt;div className="content"&gt;
                                            <br />
                                            &lt;main&gt;
                                            <br />
                                            PostingList Here
                                            <br />
                                            &lt;/main&gt;
                                            <br />
                                            &lt;aside&gt;
                                            <br />
                                            Side Content Here
                                            <br />
                                            &lt;/aside&gt;
                                            <br />
                                            &lt;/div&gt;
                                        </code>
                                    </pre>
                                    <button onClick={(e) => copySnippet(e, "threeColHTML")} className={styles.copyBtn}>
                                        Copy Snippet
                                    </button>
                                    <p style={{ textAlign: "left" }}>CSS</p>
                                    <pre className={styles.codeSnippet}>
                                        <code id="threeColCSS">
                                            main &#123; <br />
                                            width: 70%; <br />
                                            display: flex; <br />
                                            flex-wrap: wrap; <br />
                                            justify-content: space-between; <br />
                                            &#125; <br />
                                            <br /><br />
                                            aside &#123; <br />
                                            width: 30%; <br />
                                            background-color: #34393D; <br />
                                            padding: 30px; <br />
                                            border-radius: 25px; <br />
                                            height: auto; <br />
                                            max-height: 100%; <br />
                                            &#125; <br />
                                        </code>
                                    </pre>
                                    <button onClick={(e) => copySnippet(e, "threeColCSS")} className={styles.copyBtn}>
                                        Copy Snippet
                                    </button>
                                </div>
                                <div>
                                    <h3>2 Column</h3>
                                    Pages: View Post, Make Post, Rankings
                                    <br /> <br />
                                    <p style={{ textAlign: "left" }}>2 columns are created with the same styling as 3 columns, but no PostingList is used.</p>
                                    <br />
                                    <p style={{ textAlign: "left" }}>HTML</p>
                                    <pre className={styles.codeSnippet}>
                                        <code id="twoColHTML">
                                            &lt;h1&gt;Page Heading&lt;/h1&gt;
                                            <br />
                                            &lt;div className="content"&gt;
                                            <br />
                                            &lt;main&gt;
                                            <br />
                                            Main Content Here
                                            <br />
                                            &lt;/main&gt;
                                            <br />
                                            &lt;aside&gt;
                                            <br />
                                            Side Content Here
                                            <br />
                                            &lt;/aside&gt;
                                            <br />
                                            &lt;/div&gt;
                                        </code>
                                    </pre>
                                    <button onClick={(e) => copySnippet(e, "twoColHTML")} className={styles.copyBtn}>
                                        Copy Snippet
                                    </button>
                                    <p style={{ textAlign: "left" }}>CSS</p>
                                    <pre className={styles.codeSnippet}>
                                        <code id="twoColCSS">
                                            main &#123; <br />
                                            width: 70%; <br />
                                            display: flex; <br />
                                            flex-wrap: wrap; <br />
                                            justify-content: space-between; <br />
                                            &#125; <br />
                                            <br /><br />
                                            aside &#123; <br />
                                            width: 30%; <br />
                                            background-color: #34393D; <br />
                                            padding: 30px; <br />
                                            border-radius: 25px; <br />
                                            height: auto; <br />
                                            max-height: 100%; <br />
                                            &#125; <br />
                                        </code>
                                    </pre>
                                    <button onClick={(e) => copySnippet(e, "twoColCSS")} className={styles.copyBtn}>
                                        Copy Snippet
                                    </button>
                                </div>
                                <div>
                                    <h3>1 Column</h3>
                                    Pages: Profile, Discover
                                    <p style={{ textAlign: "left" }}>HTML</p>
                                    <pre className={styles.codeSnippet}>
                                        <code id="oneColHTML">
                                            &lt;div className="page-content"&gt; <br />
                                            Page Content Here <br />
                                            &lt;/div&gt;
                                        </code>
                                    </pre>
                                    <button onClick={(e) => copySnippet(e, "oneColHTML")} className={styles.copyBtn}>
                                        Copy Snippet
                                    </button>
                                    <p style={{ textAlign: "left" }}>CSS</p>
                                    <pre className={styles.codeSnippet}>
                                        <code id="oneColCSS">
                                            .page-content &#123; <br />
                                            width: 900px; <br />
                                            background-color: #34393D; <br />
                                            &#125; <br />
                                            <br />
                                            /* OR */ <br />
                                            <br />
                                            .page-content &#123; <br />
                                            width: 90%px; <br />
                                            max-width: 900px; <br />
                                            min-width: 320px; <br />
                                            background-color: #34393D; <br />
                                            border: 2px solid #793CC6; <br />
                                            &#125; <br />
                                        </code>
                                    </pre>
                                    <button onClick={(e) => copySnippet(e, "oneColCSS")} className={styles.copyBtn}>
                                        Copy Snippet
                                    </button>
                                </div>
                            </div>
                        </section>
                    </div>
                    <div className={styles.col}>

                        <section>
                            <h2 className={styles.sectionHeader}>Buttons</h2>
                            <hr />
                            <div className={styles.buttonTabs}>
                                <button onClick={handlePrimaryClick} className={styles.button1}>Primary</button>
                                <button onClick={handleSecondaryClick} className={styles.button2}>Secondary</button>
                            </div>
                            {primary && (
                                <div>
                                    <button className={styles.primaryExampleButton}>Example</button>
                                    <pre className={styles.codeSnippet}>
                                        <code id="primaryCode">
                                            padding: 10px 30px;
                                            <br />
                                            margin: 5px;
                                            <br />
                                            border-radius : 100px;
                                            <br />
                                            font-size: 1.125rem;
                                            <br />
                                            font-family: "Josefin Sans", sans-serif;
                                            <br />
                                            color : #000000;
                                            <br />
                                            background-color : #d1b140;
                                            <br />
                                            border-style: solid;
                                            <br />
                                            border-color: #000000;
                                            <br />
                                            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                                            <br />
                                            box-sizing: border-box;
                                        </code>
                                    </pre>
                                    <button onClick={(e) => copySnippet(e, "primaryCode")} className={styles.copyBtn}>
                                        Copy Snippet
                                    </button>
                                </div>
                            )}
                            {secondary && (
                                <div>
                                    <button className={styles.secondaryExampleButton}>Example</button>
                                    <pre className={styles.codeSnippet}>
                                        <code id="secondaryCode">
                                            padding: 10px 30px;
                                            <br />
                                            margin: 5px;
                                            <br />
                                            border-radius: 100px;
                                            <br />
                                            font-size: 1.125rem;
                                            <br />
                                            font-family: "Josefin Sans", sans-serif;
                                            <br />
                                            color: #ffffff;
                                            <br />
                                            background-color: #793cc6;
                                            <br />
                                            border-style: none;
                                            <br />
                                            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                                            <br />
                                            box-sizing: border-box;
                                        </code>
                                    </pre>
                                    <button onClick={(e) => copySnippet(e, "secondaryCode")} className={styles.copyBtn}>
                                        Copy Snippet
                                    </button>
                                </div>
                            )}
                        </section>

                        <section>
                            <h2>Posts Styling</h2>
                            <hr />
                            <p style={{ textAlign: "left" }}>It is recommended to use the PostingList and Post components where possible</p> <br />
                            <p style={{ textAlign: "left" }}>HTML (of an example post in a posting list)</p>
                            <pre className={styles.codeSnippet}>
                                <code id="postStylingHTML">
                                    &lt;div className="posts"&gt; <br />
                                    &lt;div className="postlist postbody"&gt; <br />
                                    Post Content Here
                                    &lt;/div&gt; <br />
                                    &lt;/div&gt;
                                </code>
                            </pre>
                            <button onClick={(e) => copySnippet(e, "postStylingHTML")} className={styles.copyBtn}>
                                Copy Snippet
                            </button>
                            <p style={{ textAlign: "left" }}>CSS (of an example post in a posting list)</p>
                            <pre className={styles.codeSnippet}>
                                <code id="postStylingCSS">
                                    .posts &#123;<br />
                                    display: flex;<br />
                                    flex-direction: column;<br />
                                    align-items: flex-start;<br />
                                    justify-content: space-between;<br />
                                    <br />
                                    width: 100%;<br />
                                    height: fit-content;<br />
                                    flex-direction: row;<br />
                                    flex-wrap: wrap;<br />
                                    gap: 20px;<br />
                                    &#125;<br />
                                    <br />
                                    .postbody &#123;<br />
                                    width: 48%;<br />
                                    <br />
                                    display: flex;<br />
                                    flex-direction: column;<br />
                                    align-items: flex-start;<br />
                                    justify-content: center;<br />
                                    gap: 1ch;<br />
                                    <br />
                                    position: relative;<br />
                                    <br />
                                    color: white;<br />
                                    font-family: "Josefin Sans", sans-serif;<br />
                                    &#125;<br />
                                    <br />
                                    .postbody .post-img &#123;<br />
                                    width: 100%;<br />
                                    height: auto;<br />
                                    &#125;<br />
                                    <br />
                                    .post-content &#123;<br />
                                    width: 100%;<br />
                                    word-wrap: break-word;<br />
                                    &#125;<br />
                                    <br />
                                    .postbody img &#123;<br />
                                    height: 30px;<br />
                                    width: auto;<br />
                                    margin: 0;<br />
                                    &#125;<br />
                                    <br />
                                    .postbody a &#123;<br />
                                    color: #40B7D1;<br />
                                    &#125;<br />
                                    <br />
                                    .post-title &#123;<br />
                                    width: 100%;<br />
                                    display: flex;<br />
                                    justify-content: space-between;<br />
                                    align-items: center;<br />
                                    &#125;<br />
                                    <br />
                                    .post-title a &#123;<br />
                                    color: white;<br />
                                    text-decoration: none;<br />
                                    &#125;<br />
                                    <br />
                                    .post-created &#123;<br />
                                    font-size: 0.75rem;<br />
                                    color: #999;<br />
                                    position: absolute;<br />
                                    bottom: 10px;<br />
                                    right: 20px;<br />
                                    &#125;<br />
                                    <br />
                                    .tagDiv &#123;<br />
                                    margin-right: 10px;<br />
                                    &#125;

                                </code>
                            </pre>
                            <button onClick={(e) => copySnippet(e, "postStylingCSS")} className={styles.copyBtn}>
                                Copy Snippet
                            </button>
                        </section>

                    </div>

                    <Modal show={showModal1} onClose={() => setShowModal1(false)}>
                        <div>
                            {/* <br /> */}
                            <h1>Purple Rain : #793cc6</h1>
                            {/* <br /> */}
                            <p className={styles.pText}>This color is used for Secondary (Smaller/Less Important) Buttons when two buttons are used, as well as borders for divs</p>
                            {/* <br /> */}
                            <p>E.g. Register Button, Comment Button </p>
                        </div>
                    </Modal>
                    <Modal show={showModal2} onClose={() => setShowModal2(false)}>
                        <div>
                            {/* <br /> */}
                            <h1>Metallic Gold : #d1b140</h1>
                            {/* <br /> */}
                            <p className={styles.pText}>This color is used for Primary(Important) Buttons when two buttons are used</p>
                            {/* <br /> */}
                            <p>E.g. Submit Buttons, Login Buttons, Post Buttons, Back Buttons</p>
                        </div>
                    </Modal>
                    <Modal show={showModal3} onClose={() => setShowModal3(false)}>
                        <div>
                            {/* <br /> */}
                            <h1>Tribecca Corner : #34393d</h1>
                            {/* <br /> */}
                            <p className={styles.pText}>This color is used for the Background of React Components</p>
                        </div>
                    </Modal>
                    <Modal show={showModal4} onClose={() => setShowModal4(false)}>
                        <div>
                            {/* <br /> */}
                            <h1>White : #ffffff</h1>
                            {/* <br /><br /> */}
                            <p className={styles.pText}>This color is used for the Text of the application</p>
                        </div>
                    </Modal>
                    <Modal show={showModal5} onClose={() => setShowModal5(false)}>
                        <div>
                            {/* <br /> */}
                            <h1>Gold Sand : #8E7839</h1>
                            {/* <br /> */}
                            <p className={styles.pText}>This color is used for special unhighlighted elements</p>
                            {/* <br /> */}
                            <p>E.g. Unhovered Buttons, Dropdown Menus</p>
                        </div>
                    </Modal>
                    <Modal show={showModal6} onClose={() => setShowModal6(false)}>
                        <div>
                            {/* <br /> */}
                            <h1 style={{
                                background: 'linear-gradient(to right, #35214E, #40B7D1)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent'
                            }}>
                                Gradient : #35214E -{'>'} #40B7D1
                            </h1>
                            {/* <br /> */}
                            <p className={styles.pText}>This gradient is used for the background of the header</p>
                            {/* <br /> */}
                            <p>[ This gradient is static throughout the website ]</p>
                        </div>
                    </Modal>
                    <Modal show={showModal7} onClose={() => setShowModal7(false)}>
                        <div>
                            {/* <br /> */}
                            <h1>Tribeca Corner : #252525</h1>
                            {/* <br /> */}
                            <p className={styles.pText}>This color is used for the Background of All Contents</p>
                        </div>
                    </Modal>
                    <Modal show={showModal8} onClose={() => setShowModal8(false)}>
                        <div>
                            {/* <br /> */}
                            <h1>Slate : #1E1E1E</h1>
                            {/* <br /> */}
                            <p className={styles.pText}>This color is used as the page background across the app.</p>
                        </div>
                    </Modal>
                    <Modal show={showModal9} onClose={() => setShowModal9(false)}>
                        <div>
                            {/* <br /> */}
                            <h1>Yellow : #F4C41A</h1>
                            {/* <br /> */}
                            <p className={styles.pText}>This color is used as a higher contrast yellow for call to action buttons, and hover highlights.</p>
                        </div>
                    </Modal>
                    <Modal show={showModal10} onClose={() => setShowModal10(false)}>
                        <div>
                            {/* <br /> */}
                            <h1>Dark Purple : #29193C</h1>
                            {/* <br /> */}
                            <p className={styles.pText}>This color is used as the background for the user profile menu dropdown in the header.</p>
                        </div>
                    </Modal>
                    <Modal show={showModal11} onClose={() => setShowModal11(false)}>
                        <div>
                            {/* <br /> */}
                            <h1>Neon Green : #00FF00</h1>
                            {/* <br /> */}
                            <p className={styles.pText}>This color is used as the border for success messages.</p>
                        </div>
                    </Modal>
                    <Modal show={showModal12} onClose={() => setShowModal12(false)}>
                        <div>
                            {/* <br /> */}
                            <h1>Green : #0D9C00</h1>
                            {/* <br /> */}
                            <p className={styles.pText}>This color is used as the text color for success messages.</p>
                        </div>
                    </Modal>
                    <Modal show={showModal13} onClose={() => setShowModal13(false)}>
                        <div>
                            {/* <br /> */}
                            <h1>Light Red : #FFE6E6</h1>
                            {/* <br /> */}
                            <p className={styles.pText}>This color is used as the background for error messages.</p>
                        </div>
                    </Modal>
                    <Modal show={showModal14} onClose={() => setShowModal14(false)}>
                        <div>
                            {/* <br /> */}
                            <h1> Light Green : #E6FFE6</h1>
                            {/* <br /> */}
                            <p className={styles.pText}>This color is used as the background for success messages.</p>
                        </div>
                    </Modal>
                    <Modal show={showModal15} onClose={() => setShowModal15(false)}>
                        <div>
                            {/* <br /> */}
                            <h1> Light Gray : #4C5359</h1>
                            {/* <br /> */}
                            <p className={styles.pText}>This color is used as the background for elements in a div with the darker gray color (#34393D).</p>
                        </div>
                    </Modal>
                </div>
            </div>
        </>
    )
}

export default StyleGuidePage
